import React from 'react';

interface WrongFeedbackProps {
    explanation?: string;
    answer?: string | number | string[] | number[];
    livesRemaining?: number;
}

function formatAnswer(answer?: string | number | string[] | number[]) {
    if (Array.isArray(answer)) return answer.join(' → ');
    if (answer === undefined || answer === null) return 'Unavailable';
    return String(answer);
}

export default function WrongFeedback({ explanation, answer, livesRemaining = 0 }: WrongFeedbackProps) {
    return (
        <div className="overflow-hidden border border-[#4a2c32] bg-[#111111] shadow-[0_0_28px_rgba(255,113,108,0.12)]">
            <div className="border-b border-[#43262c] bg-[#231517] px-6 py-4">
                <div className="flex items-center justify-between gap-4">
                    <div className="flex items-center gap-3">
                        <span className="flex h-11 w-11 items-center justify-center border border-[#ff716c] bg-[#2a1111] text-xl text-[#ff716c]">
                            !
                        </span>
                        <div>
                            <p className="font-['IBM_Plex_Mono'] text-[11px] uppercase tracking-[0.32em] text-[#ff716c]">
                                SYSTEM_REJECTED
                            </p>
                            <h3 className="mt-2 font-['Space_Grotesk'] text-3xl font-black uppercase italic text-white">
                                Data Void Detected
                            </h3>
                        </div>
                    </div>
                    <span className="border border-[#ff716c]/30 bg-[#ff716c]/10 px-3 py-2 font-['IBM_Plex_Mono'] text-[11px] uppercase tracking-[0.28em] text-[#ff716c]">
                        RE-CALIBRATE
                    </span>
                </div>
            </div>

            <div className="px-6 py-6">
                <p className="text-base leading-relaxed text-[#dedede]">
                    {explanation || 'The arena rejected that answer. Re-run the concept chain and try the next node with a cleaner read.'}
                </p>

                <div className="mt-6 grid gap-4 sm:grid-cols-2">
                    <div className="border border-[#242424] bg-[#151515] px-4 py-4">
                        <p className="font-['IBM_Plex_Mono'] text-[10px] uppercase tracking-[0.24em] text-[#767575]">
                            Correct Payload
                        </p>
                        <p className="mt-2 font-['IBM_Plex_Mono'] text-sm uppercase tracking-[0.18em] text-[#8cacff]">
                            {formatAnswer(answer)}
                        </p>
                    </div>
                    <div className="border border-[#242424] bg-[#151515] px-4 py-4">
                        <p className="font-['IBM_Plex_Mono'] text-[10px] uppercase tracking-[0.24em] text-[#767575]">
                            Lives Left
                        </p>
                        <p className="mt-2 font-['Space_Grotesk'] text-2xl font-black uppercase text-[#ff716c]">
                            {String(livesRemaining).padStart(2, '0')}
                        </p>
                    </div>
                </div>

                <div className="mt-6 border border-[#ff716c]/25 bg-[#ff716c]/8 px-5 py-4">
                    <p className="font-['IBM_Plex_Mono'] text-[11px] uppercase tracking-[0.3em] text-[#ff716c]">
                        NEXT_ACTION
                    </p>
                    <p className="mt-2 text-sm leading-relaxed text-[#f4c5c2]">
                        Reviewing the correct payload before the next node loads.
                    </p>
                </div>
            </div>
        </div>
    );
}
